<template>
  <div>
    <h2 class="mb-5">
      {{ this.$title }}
      <v-btn class="float-right" @click="back">
        <v-icon title="Back to the stack unit overview">
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <v-btn class="float-right" @click="refresh">
        <v-icon v-if="!loading" title="Refresh"> mdi-refresh </v-icon>
        <v-icon v-if="loading" title="Loading" disabled>
          mdi-timer-sand
        </v-icon>
      </v-btn>
      <v-btn
        v-if="action !== 'add'"
        :to="{ name: 'stack_unit_delete', params: { id: id } }"
        class="float-right"
      >
        <v-icon title="Delete"> mdi-delete </v-icon>
      </v-btn>
      <v-btn
        class="float-right"
        :class="help_toggle ? 'info' : ''"
        @click="toggle_help"
      >
        <v-icon title="Help"> mdi-help </v-icon>
      </v-btn>
    </h2>

    <v-form>
      <v-tabs v-model="tabs" class="mb-5">
        <v-tab>Stack Unit</v-tab>
        <v-tab>JSON</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <stack-unit-form
            :item="item"
            :form-errors="formErrors"
            :help_toggle="help_toggle"
          />
        </v-tab-item>
        <v-tab-item>
          <pre>{{ item }}</pre>
        </v-tab-item>
      </v-tabs-items>

      <v-btn color="success" class="mr-4" @click="save"> Save </v-btn>
    </v-form>
  </div>
</template>

<script>
import StackUnitForm from '@/components/form/StackUnitForm'
import api from '@/api'

export default {
  components: {
    StackUnitForm,
  },
  data() {
    return {
      id: this.$route.params.id, // @TODO: validate this.
      action: this.$route.params.action || 'add', // @TODO: validate this.
      item: {
        orientation: {},
        exposed_fields: {},
      },
      tabs: null,
      formErrors: {},
      loading: false,
      help_toggle: false,
    }
  },

  mounted() {
    this.refresh()
  },
  methods: {
    refresh() {
      if (this.action !== 'add') {
        this.loading = true
        api.get('stack-unit/' + this.id).then((response) => {
          this.loading = false
          this.item = response.data
          this.$title = [
            this.$options.filters.capitalize(this.action),
            ' stack unit ',
            this.item.name,
          ].join(' ')
        })
      }
    },

    toggle_help() {
      this.help_toggle = !this.help_toggle
    },

    back() {
      this.$router.back()
    },

    save() {
      switch (this.action) {
        case 'edit':
          api
            .put('stack-unit/' + this.id, this.item)
            .then(() => {
              this.$router.push({ name: 'stack_unit_index' })
            })
            .catch((err) => {
              this.formErrors = err.response.data.errors
            })
          break

        case 'add':
          api
            .post('stack-unit', this.item)
            .then(() => {
              this.$router.push({ name: 'stack_unit_index' })
            })
            .catch((err) => {
              this.formErrors = err.response.data.errors
            })
          break
      }
    },
  },
}
</script>
